(function () {
  'use strict';
  const config = document.getElementById('gps-measurement-script');
  if (!config || config.dataset.pageType !== 'product' || !window.gpsMeasurement || window.gpsGalleryMeasurement) return;
  if (!window.IntersectionObserver || (window.Shopify && Shopify.designMode)) return;
  window.gpsGalleryMeasurement = Object.freeze({version: '1.1.0'});
  const records = new Map();
  const viewed = new Set();
  const depths = new Set();
  let ready = false;
  function allowed() {
    try { return Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function publish(name, parameters) {
    return window.gpsMeasurement.emit(name, Object.assign({source_section: 'product_gallery'}, parameters));
  }
  function stop(record) {
    if (record.timer) clearTimeout(record.timer);
    record.timer = null;
  }
  function cancel() { records.forEach(stop); }
  function eligible(record) {
    return allowed() && document.visibilityState === 'visible' && record.visible && record.image.isConnected && record.image.complete && record.image.naturalWidth > 0;
  }
  function consider(record) {
    if (!eligible(record) || viewed.has(record.key)) { stop(record); return; }
    if (record.timer) return;
    record.timer = setTimeout(() => {
      record.timer = null;
      if (!eligible(record) || viewed.has(record.key)) return;
      if (!publish('gallery_image_view', {image_position: String(record.position), gallery_size: new Set(Array.from(records.values(), r => r.key)).size})) return;
      viewed.add(record.key);
      [2, 3, 5].forEach(depth => {
        if (viewed.size >= depth && !depths.has(depth) && publish('gallery_depth', {gallery_depth: depth + '_plus'})) depths.add(depth);
      });
    }, 1000);
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const record = records.get(entry.target);
      if (!record) return;
      record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
      consider(record);
    });
  }, {threshold: [0, 0.6, 1]});
  function scan() {
    document.querySelectorAll('#pdpGalleryMain, product-info[id^="MainProduct-"] media-gallery, section[id^="MainProduct-"] media-gallery').forEach(root => {
      const custom = root.id === 'pdpGalleryMain';
      const slides = root.querySelectorAll(custom ? '.gallery-slide' : '.product__media-item');
      slides.forEach((slide, index) => {
        if (custom && slide.dataset.gpsMediaType && slide.dataset.gpsMediaType !== 'image') return;
        const image = custom ? slide.querySelector(':scope > img') : slide.querySelector('.product__modal-opener--image .product__media img');
        if (!image || records.has(image)) return;
        let key;
        try { key = new URL(image.currentSrc || image.src, location.origin).pathname.replace(/_\d+x\d*(?=\.[^.]+$)/, ''); }
        catch (_) { return; }
        if (!key || !/\.(avif|gif|jpe?g|png|webp)$/i.test(key)) return;
        const record = {image, key, position: custom ? Number(slide.dataset.index) + 1 : index + 1, visible: false, timer: null};
        if (!Number.isSafeInteger(record.position) || record.position < 1) return;
        records.set(image, record);
        observer.observe(image);
        image.addEventListener('load', () => consider(record));
      });
    });
  }
  function resume() {
    if (!allowed() || document.visibilityState !== 'visible') { cancel(); return; }
    scan();
    if (!ready && records.size) ready = publish('gallery_ready', {gallery_size: new Set(Array.from(records.values(), r => r.key)).size});
    records.forEach(consider);
  }
  document.addEventListener('visitorConsentCollected', () => {
    cancel();
    if (!allowed()) {
      viewed.clear();
      depths.clear();
      return;
    }
    resume();
  });
  document.addEventListener('visibilitychange', resume);
  document.addEventListener('shopify:section:load', resume);
  window.addEventListener('pagehide', cancel);
  window.addEventListener('pageshow', resume);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resume, {once: true});
  if (window.Shopify && typeof Shopify.loadFeatures === 'function') Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) resume(); });
  resume();
})();
